export function px2rem(size: number, context = 16) {
  return `${size / context}rem`;
}

export function px2vw(size: number, context = 1440) {
  return `${(size / context) * 100}vw`;
}